import React from 'react';

import '../styles/AnnouncementBar.css';
import { string } from 'prop-types';

export default function AnnouncementBar({ storefrontAnnouncement }) {
    return (<div
        className={'announcement-bar'}>
        {storefrontAnnouncement}
    </div>);
}

AnnouncementBar.propTypes = {
    storefrontAnnouncement: string,
};